var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApartment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 86,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-11.9%",
    y: "-9.6%",
    width: "123.8%",
    height: "119.2%",
    filterUnits: "objectBoundingBox",
    id: "icon-apartment_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-apartment_svg__a)",
    transform: "translate(-49 -70)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#076447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.654 78.088l-.007 65.927H124.49l.02-60.938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.51 79.589v-3.07c0-1.032.9-1.873 2.012-1.873l16.124.005c1.112 0 2.011.839 2.011 1.869v3.073M108.37 144.015H86.207V76.512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3F1E3",
    d: "M128.528 144.015h12.089v-12.197h-12.089z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.531 131.82h12.092V80.27H128.53zM90.229 144.015h-4.03l.019-67.503c0-1.036.9-1.873 2.01-1.873 1.12 0 2.016.84 2.016 1.873l-.015 67.503zM104.35 76.516c0-1.036.905-1.877 2.019-1.877 1.111.003 2.014.84 2.014 1.877M108.369 144.015h-4.032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.513 83.078h-18.142V81.2c0-1.032.907-1.873 2.02-1.873h14.108c1.11 0 2.014.845 2.014 1.878v1.873z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.089 99.94h16.12v-8.434H70.09zM108.381 99.951h16.123v-8.438H108.38zM108.37 115.883H124.5v-8.44h-16.128zM108.37 131.814h16.12v-8.434h-16.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3F1E3",
    d: "M104.337 144.015H90.23v-12.204h14.107M64.21 144.015H86.2v-12.21H64.21zM108.369 131.815h16.12v12.2h-16.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.37 131.816H124.5V83.078h-16.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3F1E3",
    d: "M128.528 123.383h12.095v-7.496h-12.095zM128.531 107.452h12.092v-7.497H128.53zM128.534 91.519h12.093v-7.5h-12.093z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.237 123.376h14.107v-7.496H90.237zM90.237 107.443h14.11v-7.499h-14.11zM90.245 91.508h14.105v-7.495H90.245zM78.147 107.441v-7.5M78.147 91.506l.005-7.496M116.439 107.444v-7.492M116.444 91.513v-8.435M116.434 123.38v-7.496"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.425 138.406c0-1.554-1.355-2.812-3.023-2.812a3.098 3.098 0 00-2.52 1.265c-.538-.757-1.469-1.265-2.516-1.265-1.05 0-1.982.508-2.522 1.265-.54-.757-1.468-1.265-2.523-1.265-1.662 0-3.016 1.258-3.016 2.812l-.02 5.61h16.119l.02-5.61z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.283 144.015h16.12v-3.79h-16.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.15 138.406c0-1.554-1.347-2.812-3.018-2.812-1.056 0-1.98.508-2.519 1.265a3.093 3.093 0 00-2.522-1.265 3.118 3.118 0 00-2.525 1.265c-.536-.757-1.456-1.265-2.51-1.265-1.671 0-3.023 1.258-3.023 2.812l-.021 5.61h16.122l.017-5.61z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.012 144.015h16.122v-3.79H67.012zM78.147 123.372v-7.495M86.201 131.812l-16.122-.008.01-45.922c0-1.035.904-1.877 2.015-1.877l14.106.004-.009 47.803z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.078 131.803h16.123v-8.43H70.078zM70.083 115.877h16.124v-8.435H70.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.452 94.328c0 1.036-.896 1.874-2.013 1.874h-8.059v-4.69h10.075l-.003 2.816zM118.452 110.26c0 1.032-.899 1.874-2.013 1.874h-8.07l.011-4.69h10.072v2.816zM118.451 126.192c0 1.035-.907 1.873-2.017 1.873h-8.066l.002-4.685h10.081v2.812zM78.147 96.19H70.09v-4.684h10.074v2.811c0 1.037-.9 1.873-2.016 1.873zM78.145 128.06H70.08v-4.691l10.082.003v2.813c0 1.03-.907 1.876-2.016 1.876zM78.145 112.123h-8.061v-4.682h10.08l-.003 2.807c0 1.041-.898 1.875-2.016 1.875z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.37 76.512v3.072M104.339 135.746l.012-59.23M108.37 131.815l.032 3.78M145.57 144.008h-.917M90.244 76.512h14.106"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158 145.983c0 1.666-23.507 3.017-52.5 3.017-28.997 0-52.5-1.35-52.5-3.017 0-1.667 23.503-3.017 52.5-3.017 28.993 0 52.5 1.35 52.5 3.017",
    fill: "#10C98F",
    opacity: 0.1
  }))));
}
export default SvgIconApartment;